import { Divider, Typography } from "@mui/material";
import { Box, Stack } from "@mui/system";
import DateCollected from "./DateCollected";
import InputField from "./InputField";
import React from "react";
import { useSelector } from "react-redux";
import { getDeepViewLineageEntry } from "../../deepViewFieldMap";

interface Props {
  /** API key of the column the user clicked, e.g. "total_income_usd" */
  columnKey?: string;
}

const StageOne = ({ columnKey }: Props) => {
  const deepViewData = useSelector(
    (state: any) => state?.deepView?.deepViewData,
  );
  const lineageEntry = getDeepViewLineageEntry(deepViewData, columnKey);

  const details = [
    {
      label: "Interface",
      value: lineageEntry?.fetcher_interface_name,
      bold: true,
    },
    {
      label: "Collection Type",
      value: lineageEntry?.collection_type_name?.toUpperCase(),
    },
    { label: "Collection Method", value: lineageEntry?.collection_method_name },
    { label: "Report Name", value: lineageEntry?.fetcher_report_name },
    { label: "Format", value: lineageEntry?.format_type },
    { label: "Raw Table", value: lineageEntry?.raw_table_name },
    { label: "Website Scope", value: lineageEntry?.site_name },
  ];

  return (
    <>
      <Stack mb={1}>
        {details.map((item, index) => (
          <React.Fragment key={item.label}>
            <Typography
              fontSize={12}
              fontWeight={item.bold ? 700 : 400}
              py={0.5}
            >
              <Box
                component="span"
                sx={{
                  textTransform: "uppercase",
                  fontWeight: 400,
                  width: 150,
                  display: "inline-block",
                }}
              >
                {item.label}
              </Box>
              {item.value ?? "-"}
            </Typography>

            {index !== details.length - 1 && <Divider />}
          </React.Fragment>
        ))}
      </Stack>

      <DateCollected columnKey={columnKey} />
      <InputField columnKey={columnKey} />
    </>
  );
};

export default StageOne;